/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { formCounterSlice } from 'redux/formCounter';
import FormStepper from '../BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/components/FormStepper/formStepper';
import OnboardingFormPage from '../BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/components/OnboardingFormPage/FormPage';
import api from 'api';
import { useTranslation } from 'react-i18next';
import { useFormPath } from 'utils/useFormPath';
import { useWindowSize } from 'hooks/useWindowSize';
import CandidateDashboard from './CandidateDashboard';
import { labelToKey } from 'utils/formLabelsToKey';
import { getActingProfileUserId } from 'utils/selectedAccount';

const getFrenchPath = (path: string[]) => {
    const translations: { [key: string]: string } = {
        'Personal Info': 'Informations personnelles',
        'Additional Details': 'Détails suåpplémentaires',
        'Language Proficiency': 'Maîtrise de la langue',
        Education: 'Éducation',
        'Work Experience': "L'expérience professionnelle",
        'Job Offer': "Offre d'emploi",
        'Relatives Abroad': "Parents à l'étranger",
        'Business Ownership': "Propriété de l'entreprise",
        'Spouse/Common Law Partner': 'Époux/conjoint de fait',
        'Family Members': 'Membres de la famille',
    };

    for (let i = 0; i < path.length; i++) {
        if (path[i] in translations) {
            path[i] = translations[path[i]];
        }
    }

    return path;
};
const CandidateDashboardWrapper = () => {
    const { t } = useTranslation();
    const [completedForms, setCompletedForms] = useState<Record<string, boolean>>({});
    const { screen, purpose } = useSelector((state: RootState) => state.formCounter);
    const { set, setCanEnableSubmitButton } = formCounterSlice.actions;
    const [formOptions, setFormOptions] = useState<any>([]);
    const { id: candidateID, language_setting: language } = useSelector(
        (state: RootState) => state.user.entity
    );
    const dispatch = useDispatch<AppDispatch>();
    const formPath = useFormPath(purpose, candidateID, language);
    useEffect(() => {
        if (language === 'FR') {
            setFormOptions(getFrenchPath(formPath));
        } else {
            setFormOptions(formPath);
        }
    }, [formPath, purpose, candidateID, language]);

    const getScreenNumber = (val: string, purpose: string) => {
        const indices = formPath?.indexOf(val);
        return indices;
    };
    const handleFormChange = (val: any) => {
        let screenNumber;
        if (purpose) {
            screenNumber = getScreenNumber(val, purpose) + 1;
        } else {
            screenNumber = getScreenNumber(val, '') + 1;
        }

        dispatch(set(screenNumber));
    };

    useEffect(() => {
        //to ensure completeForm edit func executes first
        const timer = setTimeout(() => {
            getCompletedForms();
        }, 500);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screen, candidateID]);

    const getCompletedForms = async () => {
        // Skip until the user is hydrated (initial Redux state has id = 0),
        // otherwise we fire GET /candidate_info/0/completed-forms and the
        // backend rejects it.
        const profileId = getActingProfileUserId() ?? candidateID;
        if (!Number.isFinite(profileId) || profileId <= 0) return;

        const resp = await api.completedForms.getCompletedForms(profileId);
        if (resp?.data) {
            setCompletedForms(resp.data);
        }
    };
    //optimized syntax
    const [width] = useWindowSize();
    const isMobile = width <= 679;

    const isPersonalInfoCompleted = completedForms['personal_info'];

    const engFormPath = useFormPath(purpose, candidateID, 'EN');
    const canEnableSubmitButton = engFormPath
        .slice(0, engFormPath.length - 1)
        .every((form: string) => {
            return completedForms[labelToKey[form]];
        });

    useEffect(() => {
        dispatch(setCanEnableSubmitButton(canEnableSubmitButton));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canEnableSubmitButton]);

    return (
        <>
            {!isMobile ? (
                <>
                    <h1 className="font-medium"> {t('assessmentForm', { lng: language })}</h1>

                    <span className="flex">
                        <FormStepper
                            currentStep={screen}
                            handleFormChange={handleFormChange}
                            options={formOptions}
                            completedForms={completedForms}
                            isPersonalInfoCompleted={isPersonalInfoCompleted}
                        />
                        <OnboardingFormPage />
                    </span>
                </>
            ) : (
                <>
                    <CandidateDashboard />
                    <OnboardingFormPage />
                </>
            )}
        </>
    );
};

export default CandidateDashboardWrapper;
